import { createSelector } from 'reselect';
import mappings from './mappings';

export const combinedColumnsSelector = createSelector(
    state => state.impactAnalysis.impactDetailed.columns,
    columns => columns.map(column => ({
        ...column,
        ...mappings.find(col => col.id === column.id)
    }))
);

export const getImpactDetailedRows = state => (
    state.impactAnalysis.impactDetailed.impactDetailedRows
);

export const getLoading = state => (
    state.impactAnalysis.impactDetailed.loading
);

export const getEodDate = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.from;
        }
    }
    return null;
};

export const getTrades = state => (
    state.impactAnalysis.tradePricedToday.trades
);

export const getOriginalTrades = state => (
    state.impactAnalysis.tradePricedToday.originalTradesSelection
);

export const getColumns = state => (
    state.impactAnalysis.impactDetailed.columns
);
